((global,factory) => {
  global.jurisdiction = factory;
  factory(global);
})(window || this,() => {
	jurisdiction =  {
	  	//"classes"为业务域
	  	"classes":{
	  		//"classes-detail"为页面Id,唯一标识
	  		"classes-detial-signed":{
				"student":"../../classes/classes-detial-signed-student/classes-detial-signed-student.html",
				"teacher":""
			},
	  		//通讯录列表
		  	"address":{
		  		"student":"../../classes/address-student/address-student.html",
				"teacher":"../../classes/address-teacher/address-teacher.html",
				"admin":"../../classes/address-teacher/address-teacher.html",
				"classManager": "../../classes/address-teacher/address-teacher.html"
		  	},
		  	//班级答疑列表
	  		"classes-answer-list":{
	  			"student": "../../classes/classes-answer-list-student/classes-answer-list-student.html",
	  			"teacher": "../../classes/classes-answer-list-teacher/classes-answer-list-teacher.html",
	  			"admin": "../../classes/classes-answer-list-manager/classes-answer-list-manager.html",
	  			"classManager": "../../classes/classes-answer-list-teacher/classes-answer-list-teacher.html"
	  		},
	  		//班级添加/回复答疑
	  		"add-question":{
	  			"student": "../../classes/add-question-student/add-question-student.html",
	  			"teacher": "../../classes/add-question-teacher/add-question-teacher.html",
	  			"admin": "",
	  			"classManager": "../../classes/add-question-teacher/add-question-teacher.html"
	  		},
	  		//答疑教师列表
	  		"classes-teacher-list":{
	  			"student": "../../classes/classes-teacher-list-student/classes-teacher-list-student.html",
	  			"teacher": "",
	  			"admin": "../../classes/classes-teacher-list-manager/classes-teacher-list-manager.html",
	  			"classManager": ""
	  		},
	  		//考勤列表
	  		"classes-attendance-list":{
	  			"student": "",
	  			"teacher": "../../classes/classes-attendance-list-teacher/classes-attendance-list-teacher.html",
	  			"admin": "../../classes/classes-attendance-list-manager/classes-attendance-list-manager.html",
	  			"classManager": "../../classes/classes-attendance-list-manager/classes-attendance-list-manager.html"
	  		},
	  		//考勤详情
	  		"classes-attendance-detail":{
	  			"student": "",
	  			"teacher": "../../classes/classes-attendance-detail-teacher/classes-attendance-detail-teacher.html",
	  			"admin": "../../classes/classes-attendance-detail-manager/classes-attendance-detail-manager.html",
	  			"classManager": "../../classes/classes-attendance-detail-manager/classes-attendance-detail-manager.html"
	  		},
	  		//班级相册
	  		"classes-album-list":{
	  			"student": "../../classes/classes-album-list-student/classes-album-list-student.html",
	  			"teacher": "../../classes/classes-album-list-teacher/classes-album-list-teacher.html",
	  			"admin": "../../classes/classes-album-list-manager/classes-album-list-manager.html",
	  			"classManager": "../../classes/classes-album-list-manager/classes-album-list-manager.html"
	  		},
	  		//班级相片
	  		"classes-album-detail":{
	  			"student": "../../classes/classes-album-detail-student/classes-album-detail-student.html",
	  			"teacher": "../../classes/classes-album-detail-teacher/classes-album-detail-teacher.html",
	  			"admin": "../../classes/classes-album-detail-manager/classes-album-detail-manager.html",
	  			"classManager": "../../classes/classes-album-detail-manager/classes-album-detail-manager.html"
	  		},
	  		"homework-detail":{
	  			"student": "",
	  			"teacher": "",
	  			"admin": "../../classes/homework-detail-manager/homework-detail-manager.html",
	  			"classManager": "../../classes/homework-detail-manager/homework-detail-manager.html"
	  		}
	  	},
	  	"user-center":{
	  		"user-baseinfo":{
	  			"student":"../../user/user-baseinfo/user-baseinfo.html",
	  			"teacher":"../../user/user-baseinfo-teacher/user-baseinfo-teacher.html",
	  			"admin":"../../user/user-baseinfo-teacher/user-baseinfo-teacher.html"
	  		},
	  		"user-account-safe":{
	  			"student":"../../user/user-account-safe/user-account-safe.html",
	  			"teacher":"../../user/user-account-safe-teacher/user-account-safe-teacher.html",
	  			"admin":"../../user/user-account-safe-teacher/user-account-safe-teacher.html"
	  		},
	  		"setting-list":{
	  			"student":"../../setting/setting-list/setting-list.html",
	  			"teacher":"../../setting/setting-list-teacher/setting-list-teacher.html",
	  			"admin":"../../setting/setting-list-teacher/setting-list-teacher.html"
	  		},
	  		"reset-pwd":{
	  			"student":"../../setting/reset-pwd/reset-pwd.html",
	  			"teacher":"../../setting/reset-pwd-teacher/reset-pwd-teacher.html",
	  			"admin":"../../setting/reset-pwd-teacher/reset-pwd-teacher.html"
	  		},
	  		"bind-phone":{
	  			"student":"../../setting/bind-phone/bind-phone.html",
	  			"teacher":"../../setting/bind-phone-teacher/bind-phone-teacher.html",
	  			"admin":"../../setting/bind-phone-teacher/bind-phone-teacher.html"
	  		},
	  		"user-message":{
	  			"student":"../../user/user-message/user-message.html",
	  			"teacher":"../../user/user-message-teacher/user-message-teacher.html",
	  			"admin":"../../user/user-message-manager/user-message-manager.html",
	  			"classManager" : "../../user/user-message-manager/user-message-manager.html"
	  		}
	  	}
	}
})
